  export  const pantallaPregunta: Record<string, string> = {
      ConoceHijo: "PersonalizedQuestion",
      GustoHijo: "TastesSelection",
    };